/* eslint-disable @typescript-eslint/no-explicit-any */
import { AnalyticsService, UserService, firstTouchStorageKey } from '../services';
let lastPageVisitedKey = null;
function getReferrerDomain(referrer) {
  try {
    return referrer ? new URL(referrer).hostname : '';
  } catch {
    return '';
  }
}
function getReferrerWithoutSearch(referrer) {
  try {
    const url = new URL(referrer);
    return `${url.origin}${url.pathname}`;
  } catch {
    return '';
  }
}
function inferTrafficSource(params, referrerDomain) {
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  if (utmSource) return utmMedium ? `${utmSource}/${utmMedium}` : utmSource;
  if (referrerDomain.includes('google.')) return 'google_organic';
  if (referrerDomain) return 'referral';
  return 'direct';
}
function getAcquisitionProps(pathname) {
  if (typeof window === 'undefined') {
    return {
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      referrer: null,
      referrer_domain: null,
      traffic_source: 'direct',
      pathname
    };
  }
  const params = new URLSearchParams(window.location.search);
  const referrer = document.referrer || '';
  const referrerDomain = getReferrerDomain(referrer);
  const referrerWithoutSearch = getReferrerWithoutSearch(referrer);
  return {
    utm_source: params.get('utm_source') || null,
    utm_medium: params.get('utm_medium') || null,
    utm_campaign: params.get('utm_campaign') || null,
    referrer: referrerWithoutSearch || null,
    referrer_domain: referrerDomain || null,
    traffic_source: inferTrafficSource(params, referrerDomain),
    pathname
  };
}
function isFirstTouchProps(value) {
  return typeof value === 'object' && value !== null && 'initial_traffic_source' in value && typeof value.initial_traffic_source === 'string';
}
function getFirstTouchProps(acquisitionProps) {
  const firstTouch = {
    initial_utm_source: acquisitionProps.utm_source,
    initial_utm_medium: acquisitionProps.utm_medium,
    initial_utm_campaign: acquisitionProps.utm_campaign,
    initial_referrer: acquisitionProps.referrer,
    initial_referrer_domain: acquisitionProps.referrer_domain,
    initial_traffic_source: acquisitionProps.traffic_source,
    landing_pathname: acquisitionProps.pathname
  };
  if (typeof window === 'undefined') return firstTouch;
  try {
    const existing = localStorage.getItem(firstTouchStorageKey);
    if (existing) {
      const parsed = JSON.parse(existing);
      if (isFirstTouchProps(parsed)) return parsed;
    }
    localStorage.setItem(firstTouchStorageKey, JSON.stringify(firstTouch));
  } catch {
    return firstTouch;
  }
  return firstTouch;
}
function getPageVisitedKey(pathname) {
  if (pathname === undefined) return undefined;
  if (typeof window === 'undefined') return pathname;
  return `${pathname}${window.location.search}`;
}
export function useAmplitudeTracker() {
  function trackEvent(name, {
    pathname: _pathname,
    ...properties
  } = {}) {
    const currentUser = UserService.currentUser;
    const pathname = _pathname?.replace(/\/$/, '');
    const pageVisitedKey = getPageVisitedKey(pathname);
    if (name !== 'Page Visited' || pageVisitedKey !== undefined && (lastPageVisitedKey === null || pageVisitedKey.localeCompare(lastPageVisitedKey) !== 0)) {
      const acquisitionProps = name === 'Page Visited' ? getAcquisitionProps(pathname) : null;
      const eventProps = {
        user_id: currentUser?.id,
        is_staff: currentUser?.isGeovelo || currentUser?.isEcoCompteur,
        ...(acquisitionProps || {
          pathname
        })
      };

      // The first touch is persisted in localStorage, so it is only read once the event is
      // actually sent, i.e. after the user has consented.
      AnalyticsService.track(name, () => ({
        ...eventProps,
        ...(acquisitionProps ? getFirstTouchProps(acquisitionProps) : {}),
        ...properties,
        env: process.env.REACT_APP_ENV || process.env.GATSBY_APP_ENV
      }));
      if (name === 'Page Visited' && pageVisitedKey !== undefined) lastPageVisitedKey = pageVisitedKey;
    }
  }
  return {
    trackEvent
  };
}